import type { GroupType } from 'entities/board/api/types';
import type { GroupResource } from 'entities/document/model';
import { signMethodCalculate } from 'features/document/workflow/helpers/sign-method-calculate';
import type { WorkflowDesignerContext } from 'features/workflow/designer/share';
import type { WorkflowElement } from 'shared/workflow';
import { v4 as uuid } from 'uuid';

export const convertGroupToParticipantGroup =
  (type: 'sign' | 'accept') =>
  (
    group: WorkflowElement<'group', GroupType>,
    context?: WorkflowDesignerContext,
  ): GroupResource<unknown> => {
    const id = uuid();

    return {
      id,
      isNew: true,
      type: 'participant-group',
      parameters: {
        name: group.parameters.name || '',
        requiredApprovals: group.parameters.requiredApprovals || 1,
        participants: group.parameters.users.map(user => ({
          id: user.id,
          type: 'participant-user',
          parameters: {
            user,
            signMethod: signMethodCalculate(type, context?.document),
          },
        })),
      },
    };
  };
